import * as React from 'react'
import {Box, Typography} from "@mui/material"
import {formatDate, formatPriceSymbol} from "@ui-seeker/utils";
import {NotAllowedBlock} from "@components";


export default function dropColumn(name, label) {
	return [{
		name: name, label: 'Has '+label,
		options: {
			display: "excluded",
			filterType: "checkbox",
			customBodyRowRender: value => value.length ? 'Yes' : 'No'
		}
	}, {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: value => {

				return <Box sx={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
					{!value || !value.length ? (
						<NotAllowedBlock />
					) : (
						<>
							<Box>{formatPriceSymbol(value[0]['price'], value[0]['currency'])}</Box>
							<Typography variant="subtitle2">{formatDate(value[0]['date'], {isString: true})}</Typography>
							{value.map((drop, index) => (
								<Box key={index}>{drop['retailer']}</Box>
							))}
						</>
					)}
				</Box>
			}
		}
	}]
}